import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="mb-10 overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20fashion%20collage%20with%20warm%20sepia%20and%20cream%20tones%2C%20overlapping%20translucent%20layers%20of%20textile%20close-ups%20showing%20knit%20patterns%20linen%20weaves%20and%20leather%20grain%2C%20soft%20dreamy%20depth%20of%20field%20with%20sun%20flare%20peeking%20through%2C%20romantic%20nostalgic%20atmosphere%2C%20vintage%20film%20camera%20aesthetic%20with%20subtle%20light%20leaks%20and%20grain%2C%20no%20faces%20or%20text%2C%20purely%20textural%20fashion%20mood%20board%20style%20composition%20with%20ethereal%20warm%20glow&width=1200&height=600&seq=cta-collage-v4-x4&orientation=landscape"
            alt="CSSBuy Spreadsheet Hub"
            className="w-full h-auto object-cover"
          />
        </div>

        <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-snug mb-3">
          Ready to find your next
        </p>
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-snug mb-3">
          <span className="font-light italic text-foreground-500">perfect piece?</span>
        </p>
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-snug mb-8">
          Start exploring now.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 bg-foreground-900 text-white font-semibold px-10 py-4 rounded-full text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Jump to Kaspreadsheet.com
          <i className="ri-arrow-right-up-line"></i>
        </a>

        <div className="mt-10 pt-10 border-t border-background-200/70">
          <div className="flex flex-col items-center gap-4">
            <Link
              to="/article/cssbuy-spreadsheet-2026-guide"
              className="inline-flex items-center gap-2 text-primary-600 font-semibold text-sm hover:text-primary-700 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-article-line"></i>
              Read Our Complete CSSBuy Spreadsheet 2026 Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
            <div className="flex flex-wrap justify-center gap-3">
              <Link
                to="/article/kakobuy-vs-cssbuy-comparison"
                className="text-foreground-500 text-sm hover:text-primary-600 transition-colors duration-200 cursor-pointer"
              >
                Kakobuy vs CSSBuy Comparison
              </Link>
              <span className="text-foreground-300 text-sm">&middot;</span>
              <Link
                to="/article/best-budget-finds-2026"
                className="text-foreground-500 text-sm hover:text-primary-600 transition-colors duration-200 cursor-pointer"
              >
                Best Budget Finds 2026
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}